export enum IceTypeEnum{
    OWN = 'OWN',
    OTHERS = 'OTHERS'
}